import { render, staticRenderFns } from "./lp-deal.vue?vue&type=template&id=03251887&scoped=true&"
import script from "./lp-deal.vue?vue&type=script&lang=js&"
export * from "./lp-deal.vue?vue&type=script&lang=js&"
import style0 from "./lp-deal.vue?vue&type=style&index=0&id=03251887&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03251887",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
